import gql from "graphql-tag"

export const CART_USER_ERROR_FRAGMENT = gql`
  fragment CartUserErrorFragment on CartUserError {
    field
    message
  }
`
